// libs
import React from 'react';
// components
import { ChipWithInfo } from '../ChipWithInfo';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import AsyncButton from '@/widgets/AsyncButton/AsyncButton';
// constants
import { IconBroadQuery, IconExactQuery } from '@/constants/icons/svg';
import { DlsFontVariants } from '@/constants/DLSTokens';
import { BaseTheme } from '@swiggy-private/dls-web-common/dist/components';
// widgets
import Shimmer from '@/widgets/Shimmer/Shimmer';
import { KeywordMatchType } from '@local/typedefs/dist/protos/campaign/Criteria';
// styles
import styles from './SuggestedKeywords.module.scss';
import { FULL_STOP } from '@/constants/icons/unicode';
const getGroupBorderStyles = () => {
    return {
        border: `1px solid ${BaseTheme.colors.light.background_Overlay_Light}`,
    };
};
const SuggestedKeywords = (props) => {
    const { chips, handleChipSelect, loading, showRetry } = props;
    const renderLoader = () => (React.createElement(React.Fragment, null, Array(12)
        .fill(null)
        .map((_, index) => (React.createElement(Shimmer, { className: styles.placeholder, key: index })))));
    const renderNoSuggestionsView = () => (React.createElement("div", { className: styles.retryContainer },
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Med }, showRetry ? 'No suggestions found' : ''),
        showRetry && (React.createElement(AsyncButton, { onClick: props.retryFetchSuggestedKeywords, variant: "secondary", buttonSize: "small", className: styles.retryButton }, "Retry"))));
    const renderChipInfo = (params) => {
        return (React.createElement("div", { className: styles.infoContainer },
            React.createElement(IconBroadQuery, { height: 10, width: 10, fillColor: "black", opacity: 0.5 }),
            React.createElement(Text, { variant: DlsFontVariants.captionText }, params.broadSearchCount),
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, className: styles.infoContainerSeparator }, String.fromCharCode(FULL_STOP)),
            React.createElement(IconExactQuery, { height: 10, width: 10, fillColor: "black", opacity: 0.5 }),
            React.createElement(Text, { variant: DlsFontVariants.captionText }, params.exactSearchCount)));
    };
    const renderChips = () => props.chips.map((chip, index) => {
        var _a, _b, _c;
        const { keywordText } = chip;
        const minimumBid = (_a = chip[KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD].bid
            .minimumBid) !== null && _a !== void 0 ? _a : 0;
        const exactSearchCount = (_b = chip[KeywordMatchType.KEYWORD_MATCH_TYPE_EXACT].searchCount) !== null && _b !== void 0 ? _b : 0;
        const broadSearchCount = (_c = chip[KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD].searchCount) !== null && _c !== void 0 ? _c : 0;
        return (React.createElement("div", { key: index },
            React.createElement(ChipWithInfo, { label: keywordText, price: minimumBid, renderInfo: () => renderChipInfo({
                    exactSearchCount,
                    broadSearchCount,
                }), onAdd: () => handleChipSelect(chip) })));
    });
    return (React.createElement("div", { className: styles.wrapper, style: getGroupBorderStyles() }, !loading && chips.length === 0 ? (renderNoSuggestionsView()) : (React.createElement("div", { className: styles.scrollableContainer },
        React.createElement("div", { className: styles.content },
            !loading &&
                chips.length === 0 &&
                renderNoSuggestionsView(),
            loading && renderLoader(),
            !loading && chips.length > 0 && renderChips())))));
};
export default SuggestedKeywords;
